import { fontSmoothing, getFontFamily } from '../../typography';
import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    border: `1px solid ${idsTokens.textField.default.color.border.enabled}`,
  },
  select: {
    backgroundColor: idsTokens.textField.default.color.background.enabled,
    border: `1px solid ${idsTokens.textField.default.color.border.enabled}`,
    borderRadius: idsTokens.select.default.radius.standard,
    color: idsTokens.textField.default.color.input.enabled,
    minWidth: idsTokens.select.default.spacing.standard.min.width,
    minHeight: idsTokens.select.default.spacing.standard.min.height,
    height: 'auto',
    boxSizing: 'border-box',
    paddingRight: idsTokens.select.default.spacing.standard.padding.right,
    paddingBottom: idsTokens.select.default.spacing.standard.padding.bottom,
    paddingLeft: idsTokens.select.default.spacing.standard.padding.left,
    display: 'block',
    paddingTop: 7,
    '&.MuiInputBase-input': {
      paddingRight: 30,
      minWidth: idsTokens.select.default.spacing.standard.min.width,
      fontFamily: getFontFamily(idsTokens),
      ...fontSmoothing,
      '&.MuiSelect-select': {
        paddingRight: 32,
      },
    },
    '&.Mui-error': {
      backgroundColor: idsTokens.textField.error.color.background.enabled,
      border: `2px solid ${idsTokens.textField.error.color.border.enabled}`,
      paddingTop: 7,
      paddingLeft: 7,
      '&:hover': {
        border: `2px solid ${idsTokens.textField.error.color.border.hover}`,
      },
      '&:active, &[aria-pressed="true"]': {
        border: `2px solid ${idsTokens.textField.error.color.border.pressed}`,
        backgroundColor: idsTokens.textField.error.color.background.pressed,
      },
      '&.MuiInputBase-inputSizeSmall': {
        paddingTop: 3,
        paddingLeft: 7,
      },
    },
    '&.Mui-disabled': {
      backgroundColor: idsTokens.textField.default.color.background.disabled,
      border: `1px solid ${idsTokens.textField.default.color.border.disabled}`,
      WebkitTextFillColor: idsTokens.textField.default.color.input.disabled,
    },
    '&.MuiInputBase-inputSizeSmall': {
      minWidth: idsTokens.select.default.spacing.small.min.width,
      minHeight: idsTokens.select.default.spacing.small.min.height,
      paddingTop: idsTokens.select.default.spacing.small.padding.top,
      paddingRight: idsTokens.select.default.spacing.small.padding.right,
      paddingBottom: idsTokens.select.default.spacing.small.padding.bottom,
      paddingLeft: idsTokens.select.default.spacing.small.padding.left,
      lineHeight: '22px',
    },
    '&:focus': {
      borderRadius: idsTokens.select.default.radius.standard,
      outline: `2px solid ${idsTokens.textField.default.color.outline}`,
      outlineOffset: 2,
      backgroundColor: idsTokens.textField.default.color.background.focus,
    },
    '&:hover': {
      border: `1px solid ${idsTokens.textField.default.color.border.hover}`,
      backgroundColor: idsTokens.textField.default.color.background.hover,
    },
    '&:active, &[aria-pressed="true"]': {
      border: `1px solid ${idsTokens.textField.default.color.border.pressed}`,
      backgroundColor: idsTokens.textField.default.color.background.pressed,
    },
  },
  icon: {
    width: `calc(${idsTokens.iconButton.default.sizing.extraSmall.width} - 4px)`,
    height: `calc(${idsTokens.iconButton.default.sizing.extraSmall.height} - 4px)`,
    color: idsTokens.iconButton.default.color.icon.enabled,
    right: 4,
    fontSize: 16,
    padding: 4,
    boxSizing: 'content-box',
    top: 'calc(50% - 0.9em)',
    borderRadius: '50%',
    '&.Mui-disabled': {
      color: idsTokens.iconButton.default.color.icon.disabled,
      opacity: 0.6,
    },
    '.MuiInputBase-sizeSmall &': {
      fontSize: 15,
    },
  },
  iconOpen: {
    padding: 4,
    right: 4,
    top: 'calc(50% - 0.9em)',
  },
});
